/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The synchronization state of the auth support:
 *   * SYNCHRONIZED
 *   * TO_BE_SYNCHRONIZED
 *   * SYNCHRONIZATION_FAILED
 */
export enum AuthSupportSynchroState {
  SYNCHRONIZED = 'SYNCHRONIZED',
  TO_BE_SYNCHRONIZED = 'TO_BE_SYNCHRONIZED',
  SYNCHRONIZATION_FAILED = 'SYNCHRONIZATION_FAILED'
}
